import { useState, useEffect, useRef } from "react";
import { useGlobalContext } from "../context/GlobalContext";
import { PenAndPaperIcon, TrashIcon } from "../assets/icons/index.js";

const Modal = ({
  isOpen,
  onClose,
  handleDelete,
  handleUpdate,
  highlightKey,
  currentHighlight,
  onOpenNotes,
}) => {
  const modalRef = useRef(null);
  const { highlightColor, setHighlightColor } = useGlobalContext();
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (isOpen && modalRef.current) {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const rect = range.getBoundingClientRect();

        const selectionCenter = rect.left + window.scrollX + rect.width / 2;
        const modalWidth = modalRef.current.offsetWidth;
        const fixedOffsetAbove = 50;

        setPosition({
          top: rect.top + window.scrollY - fixedOffsetAbove,
          left: selectionCenter - modalWidth / 2,
        });
      }
    }
  }, [isOpen]);

  const handleColorClick = (color) => {
    if (highlightKey) {
      handleUpdate(highlightKey, color);
    } else {
      setHighlightColor(color);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="h-full w-full fixed top-0 left-0 z-50" onClick={onClose}>
      <div
        ref={modalRef}
        className="absolute dark:bg-white bg-lz-ink-mid dark:text-black text-white rounded-lg cursor-pointer"
        style={{ top: position.top, left: position.left }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex">
          <div
            id="0"
            className={`flex justify-center h-8 w-8 rounded-tl-md rounded-bl-md ${
              (currentHighlight?.color || highlightColor) === "yellow"
                ? "bg-lz-candle-dim"
                : ""
            }`}
            onClick={() => handleColorClick("yellow")}
          >
            <div className="h-6 w-6 m-auto bg-lz-yellow rounded-full" />
          </div>
          <div
            id="1"
            className={`flex justify-center h-8 w-8 ${
              (currentHighlight?.color || highlightColor) === "green"
                ? "bg-lz-candle-dim"
                : ""
            }`}
            onClick={() => handleColorClick("green")}
          >
            <div className="h-6 w-6 m-auto bg-lz-light-green rounded-full" />
          </div>
          <div
            id="2"
            className={`flex justify-center h-8 w-8 ${
              (currentHighlight?.color || highlightColor) === "pink"
                ? "bg-lz-candle-dim"
                : ""
            }`}
            onClick={() => handleColorClick("pink")}
          >
            <div className="h-6 w-6 m-auto bg-lz-light-pink rounded-full" />
          </div>
          <div
            className={`flex justify-center h-8 w-8 dark:hover:bg-lz-concrete hover:bg-lz-candle-dim`}
            onClick={() =>
              onOpenNotes({ top: position.top, left: position.left })
            }
          >
            <PenAndPaperIcon className="m-auto fill-lz-concrete dark:fill-lz-ink-mid h-5 w-5" />
          </div>
          <div
            className={`flex justify-center h-8 w-8 rounded-tr-md rounded-br-md dark:hover:bg-lz-concrete hover:bg-lz-candle-dim`}
            onClick={() => handleDelete(highlightKey)}
          >
            <TrashIcon className="m-auto fill-lz-concrete dark:fill-lz-ink-mid h-5 w-5" />
          </div>
        </div>
        {/* Triangle */}
        <div className="absolute bottom-[-8px] left-1/2 transform -translate-x-1/2 dark:text-white text-lz-ink-mid">
          <div
            className="w-0 h-0 border-l-8 border-l-transparent
                       border-r-8 border-r-transparent border-t-8 dark:border-t-white border-t-lz-ink-mid"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
